var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/moral-sent.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-70b084a6!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/moral-sent.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MoralSent.vue
// module id = 1332
// module chunks = 1